import React, { useEffect } from 'react';
import { Alert, CircularProgress } from '@mui/material';

export const JobNotificationItem = ({
  duration,
  jobData,
  onJobCompletion,
  text,
  success,
  progress
}) => {

  useEffect(() => {
    setTimeout(() => {
      onJobCompletion(jobData);
    }, duration);
  }, [duration, jobData, onJobCompletion]);

  return (
    <Alert severity={success ? 'success' : 'info'} icon={!Number.isNaN(progress)
      ? <CircularProgress variant='determinate' value={progress} size={30} />
      : undefined
    }>
      {text}
    </Alert>
  )
}